<template>
  <div class="row mt-6">
    <div v-if="notice" class="callout notice">{{notice}}</div>
    <div class="flex justify-center relative text-center mb-16">
        <div class="absolute left-0 top-4 flex items-center justify-center text-blue text-2xl cursor-pointer" @click="clickedBack">
          <fai :icon="['fas', 'chevron-left']" />
          <p class="ml-2 mb-0">back</p>
        </div>
        <p class="mb-3 text-blue text-6xl font-black font-['AileronThin']">$pringpay</p>
    </div>
    <div v-if="isProgramLoading" class="flex justify-center items-center p-4">
      <sb-loading-icon />
    </div>
    <div v-else class="medium-6 columns small-centered">
      <div class="mb-10">
        <label class="text-center field-label">enter your merrco client id</label>
        <div class="relative h-full bottom-spacing">
          <input
            :type="showClientId ? 'text' : 'password'"
            data-cy="merrco-landing-merrco-client-id-input"
            v-model="clientId"
            :disabled="!canEditSettings"
            :class="{ error: error }"
          />
          <span
            v-if="clientId"
            :class="['absolute right-3 top-2 cursor-pointer text-blue', { error: error }]"
            @click="showClientId = !showClientId">
              {{ showClientId ? 'hide' : 'show' }}
          </span>
        </div>

        <label class="text-center field-label">enter your merrco client secret</label>
        <div class="relative h-full">
          <input
            :type="showClientSecret ? 'text' : 'password'"
            data-cy="merrco-landing-merrco-client-secret-input"
            v-model="clientSecret"
            :disabled="!canEditSettings"
            :class="{ error: error }"
          />

          <span
            v-if="clientSecret"
            :class="['absolute right-3 top-2 cursor-pointer text-blue', { error: error }]"
            @click="showClientSecret = !showClientSecret">
            {{ showClientSecret ? 'hide' : 'show' }}
          </span>
        </div>
      </div>

      <p v-if="error" class="my-6 text-center error-label">
        {{ error }}
      </p>

      <div class="sb-row space-evenly bottom-spacing">
        <button @click.stop.prevent="clickedCancel" :disabled="submitting" class="link-delete">cancel</button>
        <button @click="clickedSubmit" :disabled="submitting" class="action-button button proceed">update</button>
      </div>
      <div class="sb-row center">
        <a href="https://www.merrco.com/" target="_blank">new to merrco?</a>
      </div>
    </div>
  </div>
</template>

<script>
  import UserAbilitiesMixin from '../../mixins/UserAbilitiesMixin'
  import { currentMerchantAPI } from '../../services/api/currentMerchant'
  import { mapGetters } from 'vuex'

  export default {
    name: "MerrcoLanding",
    data() {
      return {
        isProgramLoading: false,
        clientSecret: "",
        clientId: "",
        showClientSecret: false,
        showClientId: false,
        showSpringpay: false,
        submitting: false,
        notice: "",
        error: "",
      }
    },
    mixins: [UserAbilitiesMixin],
    computed: {
      merchantId() {
        return this.$route.params.id
      },
      canEditSettings() {
        return this.hasAccess(this.userAbilitiesValue, 'SETTINGS_EDIT')
      },
      withEditParam() {
        return this.$route.query.editing
      },
      ...mapGetters(
        ['userAbilitiesValue']
      )
    },
    watch: {
      clientId(newValue) {
        this.error = ""
      },
      clientSecret(newValue) {
        this.error = ""
      }
    },
    async created() {
      this.$store.dispatch('LOAD_CURRENT_USER')
      this.$store.dispatch('LOAD_CURRENT_MERCHANT')
      this.isProgramLoading = true
      try {
        const { show_springpay, merrco_credentials } = await currentMerchantAPI.GETCashPerPointsSettings('merrco_credentials')
        this.showSpringpay = show_springpay
        if (this.showSpringpay) {
          this.clientId = merrco_credentials.client_id
          this.clientSecret = merrco_credentials.client_secret
          if (this.clientId?.length && this.clientSecret?.length && !this.withEditParam) {
            this.goToCashRewardsProgramPage()
          }
        } else {
          location.replace(`/merchants/${this.merchantId}/`)
        }
      } catch (error) {
        this.notice = 'error, please refresh or contact support'
      } finally {
        this.isProgramLoading = false
      }
    },
    methods: {
      async clickedSubmit() {
        const body = { client_id: this.clientId, client_secret: this.clientSecret }
        this.submitting = true
        try {
          const result = await currentMerchantAPI.PATCHMerrcoCredentials(body)
          if (result) {
            this.goToCashRewardsProgramPage()
          } else {
            this.error = 'Credentials invalid. Please try again.'
          }
        } catch (error) {
          this.error = 'Credentials invalid. Please try again.'
        } finally {
          this.submitting = false
        }
      },
      clickedCancel() {
        this.$router.back()
      },
      clickedBack() {
        this.$router.push(`/merchants/${this.merchantId}/springpay_landing`)
      },
      goToCashRewardsProgramPage() {
        this.$router.push(`/merchants/${this.merchantId}/cash_rewards_program?type=merrco`)
      }
    }
  }
</script>

<style scoped>
input.error {
  border: 1px solid red;
}

.sb-row {
  justify-content: unset;
}
</style>
